import { ref } from 'vue';
import v2CollectionManager from '@/services/v2CollectionManager';
import Alerts from '@/lib/alerts';

export function useTags() {
    // refs
    const tagsOptions = ref([]);
    const loading = ref(false);

    const tagCategoriesCollection = ref(null);

    const initiateTagCategoriesCollection = (schoolId = null) => {
        tagCategoriesCollection.value = v2CollectionManager.create({
            listType: 'tagCategories',
            filters: {
                schoolId: schoolId
            },
            errorHandlerOptions: {
                enableAlert: true,
                rethrow: false
            }
        });
    };

    const loadTags = async () => {
        try {
            loading.value = true;
            await tagCategoriesCollection.value.refresh();
            tagsOptions.value = tagCategoriesCollection.value.list ?? [];
        } catch (error) {
            console.error('Error loading tags:', error);
            Alerts.alert({
                type: 'error',
                message: 'Failed to load tags. Please try again later.'
            });
        } finally {
            loading.value = false;
        }
    };

    async function onTagCategoriesNextPage() {
        if (tagCategoriesCollection.value.pagination.next != null) {
            await tagCategoriesCollection.value.addNextPage();
            tagsOptions.value = tagCategoriesCollection.value.list ?? [];
        }
    }

    async function handleFilterTags(searchText) {
        tagCategoriesCollection.value.filters.search = null;

        if (searchText) {
            tagCategoriesCollection.value.filters.search = searchText;
        }

        await loadTags();
    }

    const getTagsByIds = (tagIds, tagCategories) => {
        if (!Array.isArray(tagCategories)) {
            return [];
        }

        const tags = tagCategories.flatMap((option) => option.tagsRef || []);
        if (
            !Array.isArray(tagIds) ||
            tagIds.length === 0 ||
            !Array.isArray(tags) ||
            tags.length === 0
        ) {
            return [];
        }

        return tags.filter((tag) => tagIds.includes(tag.id.toString()));
    };

    return {
        tagsOptions,
        loadingTags: loading.value,
        loadTags,
        onTagCategoriesNextPage,
        handleFilterTags,
        initiateTagCategoriesCollection,
        getTagsByIds
    };
}
